<template>
  <Notifications
    group="topNotification"
    position="top center"
    width="100%"
    :max="3"
    :duration="5000"
    class="notification_group"
  >
    <template #body="props">
      <div class="notification_wrap" data-test-id="btn_close" @click="props.close">
        <div
          class="notification_close"
          data-test-id="btn_close"
          :class="{ 'd-none': props.item.data.type === 'booster-activated' }"
        >
          <i class="icon_upload_close"></i>
        </div>

        <NotificationMatch
          v-if="props.item.data.type === 'match'"
          :info="props.item.data"
        ></NotificationMatch>

        <NotificationLike
          v-else-if="props.item.data.type === 'like'"
          :info="props.item.data"
        ></NotificationLike>

        <NotificationPowerLike
          v-else-if="props.item.data.type === 'power-like'"
          :info="props.item.data"
        ></NotificationPowerLike>

        <NotificationVisit
          v-else-if="props.item.data.type === 'visit'"
          :info="props.item.data"
        ></NotificationVisit>

        <NotificationRequestPhoto
          v-else-if="props.item.data.type === 'request-photo'"
          :info="props.item.data"
        ></NotificationRequestPhoto>

        <NotificationRequestPhotoUploaded
          v-else-if="props.item.data.type === 'request-photo-uploaded'"
          :info="props.item.data"
        ></NotificationRequestPhotoUploaded>

        <NotificationMessage
          v-else-if="props.item.data.type === 'message'"
          :info="props.item.data"
        ></NotificationMessage>

        <NotificationBoosterActivated
          v-else-if="props.item.data.type === 'booster-activated'"
        ></NotificationBoosterActivated>

        <NotificationReport
          v-else-if="props.item.data.type === 'report'"
          :is-abuse-action="props.item.data.isAbuseAction"
        ></NotificationReport>

        <NotificationCreditsAdded
          v-else-if="props.item.data.type === 'credits-added'"
        ></NotificationCreditsAdded>

        <NotificationSubscriptionPaymentSuccess
          v-else-if="props.item.data.type === 'subscription-payment-success'"
        ></NotificationSubscriptionPaymentSuccess>

        <NotificationSubscriptionPaymentFailed
          v-else-if="props.item.data.type === 'subscription-payment-failed'"
        ></NotificationSubscriptionPaymentFailed>

        <NotificationAccountActivated
          v-else-if="props.item.data.type === 'account-activated'"
        ></NotificationAccountActivated>

        <NotificationAccountDeactivated
          v-else-if="props.item.data.type === 'account-deactivated'"
        ></NotificationAccountDeactivated>

        <NotificationNewVersion
          v-else-if="props.item.data.type === 'new-version'"
        ></NotificationNewVersion>
        <NotificationGeneral
          v-else-if="props.item.data.type === 'general'"
          :text="props.item.data.text"
          :icon="props.item.data.icon"
          :mode="props.item.data.mode"
        >
        </NotificationGeneral>
        <NotificationText
          v-else-if="props.item.data.type === 'text'"
          :content="props.item.data.text"
          :icon="props.item.data.icon"
          :is-svg="props.item.data.isSvg"
        />
        <NotificationReward
          v-else-if="props.item.data.type === 'reward'"
          :content="props.item.data.text"
          :icon="props.item.data.icon"
        />
        <NotificationAstroRomantic
          v-else-if="props.item.data.type === 'astro-romantic'"
          :content="props.item.data"
        />
        <NotificationStackActivity
          v-else-if="props.item.data.type === 'stack-activity'"
          :content="props.item.data"
        />
        <!-- @TODO optimization NotificationActivity for match, like, visit, request-photo, message components  -->
        <NotificationActivity
          v-else-if="props.item.data.type === 'mutual-activity'"
          :category="props.item.data.category"
          @action="props.item.data.action.click"
          @close="props.item.data.action.close"
          @disappear="props.item.data.action.disappear"
        >
          <template #icon>
            <NotificationActivityIcon :name="props.item.data.iconName" />
          </template>
          <template #avatar>
            <NotificationActivityAvatar
              :is-locked="props.item.data.isLocked"
              :form="props.item.data.avatarForm"
              :photo-id="props.item.data.photoId"
            />
          </template>
          <template #header>{{ props.item.data.header }}</template>
          <template v-if="props.item.data.description.length" #description>{{
            props.item.data.description
          }}</template>
          <template #action>{{ props.item.data.actionText }}</template>
        </NotificationActivity>
      </div>
    </template>
  </Notifications>
</template>

<script lang="ts" setup>
import NotificationAccountActivated from '@/components/notification/components/notification-account-activated/NotificationAccountActivated.vue';
import NotificationAccountDeactivated from '@/components/notification/components/notification-account-deactivated/NotificationAccountDeactivated.vue';
import NotificationAstroRomantic from '@/components/notification/components/notification-astro-romantic/NotificationAstroRomantic.vue';
import NotificationBoosterActivated from '@/components/notification/components/notification-booster-activated/NotificationBoosterActivated.vue';
import NotificationCreditsAdded from '@/components/notification/components/notification-credits-added/NotificationCreditsAdded.vue';
import NotificationGeneral from '@/components/notification/components/notification-general/NotificationGeneral.vue';
import NotificationLike from '@/components/notification/components/notification-like/NotificationLike.vue';
import NotificationMatch from '@/components/notification/components/notification-match/NotificationMatch.vue';
import NotificationMessage from '@/components/notification/components/notification-message/NotificationMessage.vue';
import NotificationNewVersion from '@/components/notification/components/notification-new-version/NotificationNewVersion.vue';
import NotificationPowerLike from '@/components/notification/components/notification-power-like/NotificationPowerLike.vue';
import NotificationActivityAvatar from '@/components/notification/components/notification-redesign/notification-activity/components/notification-activity-avatar/NotificationActivityAvatar.vue';
import NotificationActivityIcon from '@/components/notification/components/notification-redesign/notification-activity/components/notification-activity-icon/NotificationActivityIcon.vue';
import NotificationActivity from '@/components/notification/components/notification-redesign/notification-activity/NotificationActivity.vue';
import NotificationReward from '@/components/notification/components/notification-redesign/notification-reward/NotificationReward.vue';
import NotificationText from '@/components/notification/components/notification-redesign/notification-text/NotificationText.vue';
import NotificationReport from '@/components/notification/components/notification-report/NotificationReport.vue';
import NotificationRequestPhoto from '@/components/notification/components/notification-request-photo/NotificationRequestPhoto.vue';
import NotificationRequestPhotoUploaded from '@/components/notification/components/notification-request-photo-uploaded/NotificationRequestPhotoUploaded.vue';
import NotificationStackActivity from '@/components/notification/components/notification-stack-activity/NotificationStackActivity.vue';
import NotificationSubscriptionPaymentFailed from '@/components/notification/components/notification-subscription-payment-fail/NotificationSubscriptionPaymentFailed.vue';
import NotificationSubscriptionPaymentSuccess from '@/components/notification/components/notification-subscription-payment-success/NotificationSubscriptionPaymentSuccess.vue';
import NotificationVisit from '@/components/notification/components/notification-visit/NotificationVisit.vue';
</script>

<style lang="scss" src="./style.scss"></style>
